import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/nologo.webp';
import screenshot_target from '../../../images/letterfunnel/carlobogerd.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Carlo Bogerd"
      firstname="Carlo"
      companyname="HDF Cancer Monitoring"
      competition="Natera en Guardant Health"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/carlobogerd.js